import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../../services/sidebar.service';
import { environment } from '../../../../environments/environment';

@Component({ selector: 'app-sidebar', standalone: true, imports: [RouterModule, MatIconModule, MatButtonModule, TranslateModule, CommonModule], templateUrl: './sidebar.component.html', styleUrl: './sidebar.component.scss' })
export class SidebarComponent implements OnInit {
  isCollapsed = true;
  readonly version = environment.version;
  get isCommerciale(): boolean { return sessionStorage.getItem('commerciale') === 'true'; }
  constructor(private sidebarService: SidebarService) {}
  ngOnInit(): void { this.sidebarService.isCollapsed$.subscribe((collapsed) => this.isCollapsed = collapsed); }
  closeSidebar(): void { this.sidebarService.setCollapsedState(true); }
}
